module.exports = __webpack_public_path__ + "media/components/blocks/ExploreAndDiscover/star_rating-f666446241d7a2a22ae454ac55fbb8a7.png";